<template>
  <app-layout
    :state="state"
    header-type="landing"
  >
    <template #header>
      <div
        class="flex items-baseline"
        :class="{
          'pb-6' : tabs.length > 1
        }"
      >
        <div class="flex-1">
          <h1 class="text-3xl md:text-4xl font-light">
            {{ state.funding_pot.name }}
          </h1>
          <p class="text-xl md:text-2xl font-semibold">
            {{ state.marking_phase ? `${state.marking_phase.name}` : 'Assessments' }}
          </p>
        </div>
        <div
          v-if="$AuthUser.access_level === 'admin'"
          class="flex-no-shrink ml-8 w-48"
        >
          <app-button
            tag="a"
            :href="route('funding.assessments.index', state.funding_pot.id)"
            colour="white"
          >
            Assessment Admin
          </app-button>
        </div>
      </div>
    </template>
    <app-header>
      <template #navigation>
        <ul v-if="tabs.length > 1 && showTabs">
          <li
            v-for="(tab, index) in tabs"
            :key="index"
          >
            <a
              :href="route(tab.route, [state.funding_pot.id, tab.id])"
              :class="{
                'is-active': route().current(tab.route, [state.funding_pot.id, tab.id]) && currentMarkingId === tab.id
              }"
            >
              {{ tab.name }}
            </a>
          </li>
        </ul>
      </template>
    </app-header>
    <template #tertiary>
      <portal-target
        name="tertiary"
        slim
      />
    </template>
    <div
      v-if="state.marking_phase && state.marking_phase.locked"
      class="container mt-6"
    >
      <div class="bg-neutral-100 border border-neutral-300 text-neutral-800 pl-4 pr-6 py-2 flex items-center">
        <icon
          icon="important"
          class="w-6 h-6 icons-neutral mr-2"
        />
        <p>
          Assessments for this phase are currently locked. If you believe that this is incorrected, please contact <a
            :href="$config.emails.technical"
            class="text-black hover:border-neutral-800"
          >technical support</a>.
        </p>
      </div>
    </div>
    <slot />
  </app-layout>
</template>

<script>
export default {
  name: "AssessmentsBase",
  props: {
    showTabs: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentRoute() {
      return this.state.route;
    },
    currentMarkingId() {
      return this.state?.marking_phase?.id ?? false
    },
    competitionType() {
      return this.state.competition?.type?.name ?? false
    },
    tabs() {
      return this.state.marking_phases.map(phase => ({
        id: phase.id,
        name: phase.name,
        route: 'assessments.phases.view'
      }))
    }
  }
};
</script>
